import Modal from "src/components/Common/UI/Modal/Modal";
import { usePhoneLineBillingReport } from "./hooks/usePhoneLineBillingReport";
import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import { useEffect } from "react";
import { usePhoneLineBillingDetails } from "./hooks/usePhoneLineBillingDetails";

const PhoneLineBillingReport = ({handleCloseModal, phoneNumber}: PhoneLineBillingReportProps) => {
  const {
    data: reportData,
    columns: reportColumns,
    loadingDone: reportLoadingDone,
    totalRecords: reportTotalRecords,
    errorData: reportErrorData
  } = usePhoneLineBillingReport({phoneNumber: phoneNumber});
  
  const {
    data: detailsData,
    columns: detailsColumns,
    loadingDone: detailsLoadingDone,
    totalRecords: detailsTotalRecords,
    errorData: detailsErrorData
  } = usePhoneLineBillingDetails({phoneNumber: phoneNumber});

  useEffect(() => {
    if(detailsErrorData || reportErrorData) {
      handleCloseModal();
    }
    return;
  },[phoneNumber])

  return (
    <Modal
      isOpen={true}
      closeFilterModal={handleCloseModal}
      title={"Εγγραφές συγκεκριμένης γραμμής"}  
      size="full"
    >
      {detailsLoadingDone ? (
        <Table
          columns={detailsColumns}
          data={detailsData}
          defaultOrderByKeyFilter={"id"}
          showNumberOfRows={true}
          rowSelection={false}
          multipleRowSelection={false}
          actionRowId={"id"}
          debugMode={false}
          noDataFoundTitle="No Billings yet"
          isChangeOrderOrVisibilityEnable={false}
          hiddenColumnsForUser={["deleted"]}
          textPosition="center"
          maxHeight="33rem"
          numberOfRows={detailsTotalRecords}
          numberOfRowsTitle="Εγγραφές"
          pagerVisibility={false}
          minPageSize={10000}
        />
      ) : (
        <LoadingSpinner />
      )}

      {reportLoadingDone ? (
        <>
          <Table
            columns={reportColumns}
            data={reportData}
            defaultOrderByKeyFilter={"id"}
            showNumberOfRows={true}
            rowSelection={false}
            multipleRowSelection={false}
            actionRowId={"id"}
            debugMode={false}
            noDataFoundTitle="No Billings yet"
            isChangeOrderOrVisibilityEnable={false}
            hiddenColumnsForUser={["deleted"]}
            textPosition="center"
            maxHeight="26rem"
            numberOfRows={reportTotalRecords}
            numberOfRowsTitle="Εγγραφές"
            pagerVisibility={false}
            minPageSize={10000}
          />
          <div className="p-2 text-center" style={{backgroundColor: "#EBEFFD"}}>
            {`Αριθμός εγγραφών: ${reportTotalRecords}`}
          </div>
        </>
      ) : (
        <LoadingSpinner />
      )}
    </Modal>
  )
}

export default PhoneLineBillingReport;

interface PhoneLineBillingReportProps {
  handleCloseModal: () => void;
  phoneNumber: string;
}
